import { API } from "aws-amplify";

const API_NAMES = {
  VITALICIAS: "api-vitalicias",
};

const API_PATHS = {
  ANULAR_OPERACION: "/solicitud",
};

interface AnulacionData {
  tipoAnulacion: string;
  motivoAnulacion: string;
}

interface AnulacionRequest {
  id: string;
  anulacion: AnulacionData;
}

export const anularOperacionRV = async (params: AnulacionRequest) => {
  const request = {
    body: { payload: params },
    headers: {},
  };

  try {
    const response = await API.patch(
      API_NAMES.VITALICIAS,
      API_PATHS.ANULAR_OPERACION,
      request
    );
    return response;
  } catch (error) {
    console.error("Error en anularOperacionRV:", error);
    throw error;
  }
};
